import styled from "styled-components"
import carrierBackground from "../../assets/images/messenger.svg"

export const ContactButton = styled.a`
  position: fixed;
  z-index: 999;
  right: 24px;
  bottom: 24px;
  width: 60px;
  height: 60px;
  background: url(${carrierBackground});
  padding: 0px;
  border-radius: 60px;
`
